import { useSearchParams, useParams } from 'react-router-dom';
import { useStore } from '@hooks/useStore';
import { useMyTranslations } from '@hooks/useMyTranslations';
import { useGetBrandData } from '@hooks/useGetBrandData';
import { useMyQuery } from '@hooks/useMyQuery';
import { PageHeader } from '@components/Core/PageHeader';
import { AppLoader } from '@components/Core/AppLoader';
import CatalogueForm from '@forms/CatalogueForm';
import { StatusType } from '@/types/common';
import { editCatalogueTranslations } from './translations';
import { EditCatalogueTransFields } from './types';

function EditCatalogue() {
  const {
    brandsStore: { brand },
    cataloguesStore: { getCatalogue, catalogue },
  } = useStore();

  const { catalogueId } = useParams();
  const [params, _] = useSearchParams();

  const { isFetching: isFetchingCatalogue } = useMyQuery({
    queryKey: ['getCatalogue'],
    queryFn: () => {
      const status = params.get('status') as StatusType;
      if (catalogueId && status) return getCatalogue({ id: catalogueId, status });
      else return null;
    },
    enabled: !!catalogueId && !!params.get('status'),
    staleTime: 0,
  });

  const { t } = useMyTranslations<EditCatalogueTransFields>([editCatalogueTranslations.name]);

  const { isFetching, text } = useGetBrandData(t('edit catalogue'));

  return (
    <div className="page-container">
      <PageHeader text={text} />
      {(isFetching || isFetchingCatalogue) && <AppLoader />}
      {!isFetching && !isFetchingCatalogue && brand && catalogue && (
        <CatalogueForm brandId={brand.id} catalogue={catalogue} />
      )}
    </div>
  );
}

export default EditCatalogue;
